"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var CardTestimonial = function CardTestimonial(_ref) {
  var heading = _ref.heading,
    text = _ref.text,
    image = _ref.image,
    emoji = _ref.emoji;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-testimonial-card d8-u-relative flex flex-column justify-between height-100% d8-u-radius-md"
  }, image && /*#__PURE__*/_react["default"].createElement("div", {
    className: "aspect-16-9"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: image,
    alt: heading
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-component-padding"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component text-center"
  }, heading && /*#__PURE__*/_react["default"].createElement("h3", {
    className: (0, _classnames["default"])('card--basic__heading', 'd8-u-ls-sm', 'text-md')
  }, heading, " ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "testimonial-emoji"
  }, emoji)), text && /*#__PURE__*/_react["default"].createElement("p", null, text))));
};
CardTestimonial.propTypes = {
  heading: _propTypes["default"].string,
  text: _propTypes["default"].string,
  image: _propTypes["default"].string,
  emoji: _propTypes["default"].string
};
var _default = exports["default"] = CardTestimonial;